import { APIConstants } from './constants';

const MAPS_ID = 'googleMaps';

export const loadGoogleMaps = (callback) => {
  const existingScript = document.getElementById(MAPS_ID);

  if (!existingScript) {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${APIConstants.googlePlacesApiKey}&libraries=places`;
    script.id = MAPS_ID;
    document.body.appendChild(script);

    script.onload = () => {
      if (callback) callback();
    };
  }

  if (existingScript && callback) callback();
};
